import { render, staticRenderFns } from "./PlanDowngradeModal.vue?vue&type=template&id=09bd97a4&scoped=true&"
import script from "./PlanDowngradeModal.vue?vue&type=script&lang=js&"
export * from "./PlanDowngradeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bd97a4",
  null
  
)

export default component.exports